<template>
  <div class="building_container">
    <!-- 경고 팝업 -->
    <AlertModal v-if="isAlertModal" :alertText="alertText" @closeModal="isAlertModal = false" />
    <!-- 큐레이션 미리 보기 -->
    <CurationInfo v-if="showCurationInfo" :curationInfo="curationInfo" @closeCurationInfo="showCurationInfo = false" />
    <!-- 임시저장 완료 모달 -->
    <CancelModal v-if="cancelStatus" />
    <!-- 중간 저장 -->
    <CommonConfirm
      v-if="cancelCheckStatus"
      :confirmid="'cancelcheckmodal'"
      @close-modal="onCancelCheckStatusConfirmNo"
      @confirm-modal="onCancelCheckStatusConfirmYes"
    >
      <template #contents>
        <div class="stopmodal_body">
          <h3 class="stopmodal_text1">
            등록중인 스페이스를 저장할까요?
          </h3>
        </div>
      </template>
    </CommonConfirm>
    <!-- 스페이스 등록 템플릿 -->
    <SpaceManageSlot :progress="84" :closefn="backPage">
      <template #pagename>
        스페이스 등록
      </template>

      <template #spacestatus>
        어떤 시대의 음악을 좋아하시나요?
      </template>

      <template #spacebody>
        <ul class="period_list">
          <li v-for="item in periodList" :key="item.id">
            <button
              tabindex="0"
              type="button"
              class="period_item_circle cursor"
              :class="{ active: selectPeriod.includes(item.value) }"
              @click.prevent="onClickPeriod(item)"
              @keydown.enter.prevent="onClickPeriod(item)"
            >
              <span class="peroid_item_text">{{ item.text }}</span>
            </button>
          </li>
        </ul>
      </template>
    </SpaceManageSlot>
    <!-- Footer -->
    <BuildingManageFooter :rightbtndisabled="rightBtnDisabled" :leftbtnfn="onClickPre" :rightbtnfn="onUpdateCuration">
      <template #footerleft>
        <PreViewSelectCuration
          :color="color"
          :selectkey="['color', 'material', 'target', 'country', 'genre']"
          :material="bottomMaterialList"
          :target="target"
          :country="domesticRate"
          :genre="genre"
          @click-detailmodal="onClickDetailModal"
        />
      </template>
    </BuildingManageFooter>
  </div>
</template>
<script>
import CancelModal from '@/components/modal/Space/CancelModal.vue';
import SpaceManageSlot from '@/slot/SpaceManageSlot.vue';
import BuildingManageFooter from '@/components/Building/BuildingManageFooter.vue';
import PreViewSelectCuration from '@/components/Building/PreViewSelectCuration.vue';
import AlertModal from '@/components/modal/Space/AlertModal.vue';
import CurationInfo from '@/components/modal/Space/CurationInfo.vue';
import CommonConfirm from '@/components/common/CommonConfirm.vue';
import {
  automaticRecommOfPreferMusic,
  checkSubscribe,
  getCurationInfoApi,
  updateConfirmCuration,
  updateCurationAllTemp
} from '@/service/api/profileApi';
import { curationValidation, isGoFavoriteMusic } from '@/utils/Utils';
export default {
  props: {
    updatecurationinfo: {
      type: Function,
      required: false,
      default: null
    },
    linkmyspace: {
      type: Function,
      required: false,
      default: null
    }
  },
  components: {
    SpaceManageSlot,
    BuildingManageFooter,
    PreViewSelectCuration,
    AlertModal,
    CurationInfo,
    CancelModal,
    CommonConfirm
  },
  data() {
    return {
      selectPeriod: [],
      btnDisabled: false,
      selectSpaceId: localStorage.getItem('spaceId'),
      curationInfo: null,
      curationObject: null,
      domesticRate: 0,
      color: null,
      bottomMaterialList: [],
      target: [],
      genre: [],
      genrevalue: [],
      genreTuneNvalue: [],
      genreTuneYvalue: [],
      isAlertModal: false,
      alertText: '',
      showCurationInfo: false,
      cancelCheckStatus: false,
      cancelStatus: false
    };
  },
  created() {
    this.getCurationInfo();
  },
  methods: {
    onCancelCheckStatusConfirmNo() {
      this.linkmyspace(this.selectSpaceId);
    },
    async onCancelCheckStatusConfirmYes() {
      const { isSuccess, msg } = await this.updatecurationinfo(this.curationObject);
      if (isSuccess) {
        this.cancelCheckStatus = false;
        this.cancelStatus = true;
      } else {
        alert(msg);
      }
    },
    onClickDetailModal() {
      this.showCurationInfo = true;
    },
    async getCurationInfo() {
      try {
        const { data } = await getCurationInfoApi(this.selectSpaceId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          this.curationInfo = result;
          const { period, genre, domesticRate, target, material, color, genreTuneN, genreTuneY } = result;
          if (period) {
            const peroidList = this.$store.getters['curation/getPeroid'];
            period.forEach(element => {
              const find = peroidList.find(item => item.value3 === element);

              if (find) {
                this.selectPeriod.push(find.value);
              }
            });

            // 장르
            if (genre) {
              this.genre = [...this.genre, ...genre];
              genre.forEach((ele, index) => {
                const genreFind = this.$store.getters['curation/getGenreValue'](ele);
                if (genreFind) {
                  // 장르 리스트 추가
                  this.genrevalue.push(parseInt(genreFind.value));
                }
              });
            }

            // 보컬있음
            if (genreTuneN) {
              this.genre = [...this.genre, ...genreTuneN];
              genreTuneN.forEach(ele => {
                const genreFind = this.$store.getters['curation/getGenreValue'](ele);
                if (genreFind) {
                  // 장르 리스트 추가
                  this.genreTuneNvalue.push(parseInt(genreFind.value));
                }
              });
            }

            // 보컬없음
            if (genreTuneY) {
              this.genre = [...this.genre, ...genreTuneY];
              genreTuneY.forEach(ele => {
                const genreFind = this.$store.getters['curation/getGenreValue'](ele);
                if (genreFind) {
                  // 장르 리스트 추가
                  this.genreTuneYvalue.push(parseInt(genreFind.value));
                }
              });
            }

            // 국내곡 비율
            this.domesticRate = parseInt(domesticRate);

            // 고객층
            this.target = target;

            // 소재
            this.bottomMaterialList = material;

            // 색상
            this.color = color;
          }
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log('큐레이션 정보 조회 : ' + error);
      }
    },
    backPage() {
      checkSubscribe(this.selectSpaceId).then(res => {
        const { resultCd, result } = res.data;
        if (resultCd === '0000') {
          if (result === 'S') {
            this.cancelCheckStatus = true;
            // 장르 값 저장
            this.curationObject = {
              spaceId: this.selectSpaceId,
              peroid: this.selectPeriod
                .map(item => parseInt(item))
                .sort((a, b) => a - b)
                .join(',')
            };
          } else {
            this.$router.push({ name: 'buildingBridge' }).catch(() => {});
          }
        }
      });
    },
    onClickPre() {
      this.$router.push({ name: 'SpaceInsertGenreV2' }).catch(() => {});
    },
    onClickPeriod(item) {
      const { value } = item;
      const findIndex = this.selectPeriod.findIndex(findItem => parseInt(findItem) === value);
      if (findIndex > -1) {
        this.selectPeriod.splice(findIndex, 1);
      } else {
        this.selectPeriod.push(parseInt(value));
      }
    },
    async onUpdateCuration() {
      let genre = [];
      if (this.genrevalue.length > 0) {
        genre = [...this.genrevalue];
      }

      if (this.genreTuneNvalue.length > 0) {
        genre = [...genre, ...this.genreTuneNvalue];
      }

      if (this.genreTuneYvalue.length > 0) {
        genre = [...genre, ...this.genreTuneYvalue];
      }

      const { text, isAlert } = curationValidation(
        {
          domesticRate: this.domesticRate
        },
        genre,
        this.selectPeriod
      );
      if (isAlert) {
        this.isAlertModal = isAlert;
        this.alertText = text;

        return true;
      }

      // 큐레이션 업데이트
      const period = this.selectPeriod
        .map(item => parseInt(item))
        .sort((a, b) => a - b)
        .join(',');
      const sendObj = {
        period,
        spaceId: this.selectSpaceId
      };
      try {
        this.btnDisabled = true;
        const { data: curationTempData } = await updateCurationAllTemp(sendObj);
        const { resultCd } = curationTempData;
        if (resultCd === '0000') {
          const { data: confirmCurationData } = await updateConfirmCuration(
            this.selectSpaceId,
            this.curationInfo.curationId
          );
          const { resultCd: confirmCurationResultCd } = confirmCurationData;
          if (confirmCurationResultCd === '0000') {
            const isGo = isGoFavoriteMusic(this.genrevalue);
            if (isGo) {
              this.$router.push({ name: 'SpaceInsertStoreFavoriteV2' }).catch(() => {});
            } else {
              const { data: recommPreferData } = await automaticRecommOfPreferMusic(this.curationInfo.curationId);
              const { resultCd: recommPreferResultCd } = recommPreferData;
              if (recommPreferResultCd !== '0000') return false;
              this.$router.push({ path: `/space/insertStore5/${this.curationInfo.curationId}` }).catch(() => {});
            }
          } else {
            throw Error('updateConfirmCuration error : ' + confirmCurationResultCd);
          }
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log('큐레이션 정보 업데이트 API Error : ' + error);
      } finally {
        this.btnDisabled = true;
      }
    }
  },
  computed: {
    rightBtnDisabled() {
      if (this.selectPeriod.length === 0) {
        return true;
      }
      return this.btnDisabled;
    },
    periodList() {
      return this.$store.getters['curation/getPeroid'];
    }
  }
};
</script>
<style scoped src="@/assets/css/building/spaceinsertperiod.css"></style>
